import qs from 'qs'
import axios from '../config/axios.js'
import { getApiUrl } from '../config/baseUrl.js'
let config = { headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' } };
let configV1 = { headers: { 'Content-Type': 'application/json;charset=UTF-8' } };
let configV2 = { headers: { 'Content-Type': 'multipart/form-data;charset=UTF-8' } };
const BASE_URL_V1 = getApiUrl('/api/spark-collage-web')
export const readServer = {
  examList: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/examList`, {params: params}).then(res => res.data)
  },
  addPaper: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/addExaminationPapers`, qs.stringify(params), config).then(res => res.data)
  },
  deletePaper: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/deleteExaminationPapers`, qs.stringify(params)).then(res => res.data)
  },
  editPaper: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/editExaminationPapers`, qs.stringify(params), config).then(res => res.data)
  },
  paperQuestion: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/examinationPapers`, {params: params}).then(res => res.data)
  },
  publishExam: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/publishExam`, params, {skipErrorHandling: true}, configV1).then(res => res.data)
  },
  downloadPaper: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/downloadPaperFile`, qs.stringify(params), {responseType: 'blob'}).then(res => res.data)
  },
  beforeDownloadPaper: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/downloadPaper`, {params: params}).then(res => res.data)
  }
}
export const readExamServer = {
  examList: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/examinationQueryList`, {params: params}).then(res => res.data)
  },
  examDetail: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/queryExamInfo`, {params: params}).then(res => res.data)
  },
  deleteExam: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/deleteExamByExamId`, qs.stringify(params)).then(res => res.data)
  },
  scoreList: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/examinationUserScoreList`, {params: params}).then(res => res.data)
  },
  examAnalyse: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/examinationInfoAnalysis`, {params: params}).then(res => res.data)
  },
  exportScore: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/examUserScoreExport`, qs.stringify(params)).then(res => res.data)
  },
  quickComposeExam: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/quickComposeExam`, params, configV1).then(res => res.data)
  },
  quickComposeRptExam: (params) => {
    return axios.post(`${BASE_URL_V1}/examination/quickComposeRptExam`, params, configV1).then(res => res.data)
  },
  countStudyByModality: (params) => {
    return axios.get(`${BASE_URL_V1}/examination/countStudyByModality`, {params: params}).then(res => res.data)
  }
}
export const sparkQuestionServer = {
  questionList: (params) => {
    return axios.get(`${BASE_URL_V1}/question/sparkQuestions`, {params: params}).then(res => res.data)
  },
  questionDetail: (params) => {
    return axios.get(`${BASE_URL_V1}/question/sparkQuestionInfo`, {params: params}).then(res => res.data)
  },
  questionLevelList: (params) => {
    return axios.get(`${BASE_URL_V1}/question/sparkQuestionLevelCount`, {params: params}).then(res => res.data)
  },
  sparkQuestionDicCount: (params) => {
    return axios.get(`${BASE_URL_V1}/question/sparkQuestionDicCount`, {params: params}).then(res => res.data)
  }
}
export const sparkFileServer = {
  sparkQuestionImgInfo: (params) => {
    return axios.get(`${BASE_URL_V1}/question/sparkQuestionImgInfo`, {params: params}).then(res => res.data)
  },
}
export const sparkSystemServer = {
  orgList: (params) => {
    return axios.get(`${BASE_URL_V1}/organization/list`, {params: params}).then(res => res.data)
  }
}


// WEBPACK FOOTER //
// ./src/api/server/paper.js